export const APP_SNACKBAR_EVENT = 'app-snackbar';

export const showAppSnackbar = (message, severity = 'success') => {
    if (!message) return;

    window.dispatchEvent(
        new CustomEvent(APP_SNACKBAR_EVENT, {
            detail: { message, severity },
        })
    );
};
